const Colors = {
  AzulMediline: '#002C54',
  AzulMedilineClaro: '#003F77', // fin del gradiente de marca (azul, primario)
  AzulMediline10: 'rgba(0, 44, 84, 0.1)', // fondo translúcido azul (chips de icono)
  RojoMediline: '#DA2037',
  RojoMedilineOscuro: '#8E131F', // fin del gradiente de marca (rojo, acción)
  RojoMediline10: 'rgba(218, 32, 55, 0.1)', // fondo translúcido rojo
  Negro: '#000000',
  GrisMedio: '#757575', // texto secundario / subtítulos
  Error: '#EB5757',
  GrisClaro: '#BDBDBD',
  GrisBorde: '#EBEBEB', // bordes sutiles (cards)
  Azul75: 'rgba(0, 44, 84, 0.75)',
  Orange: '#EB6836'
};
export default Colors;
